// export this package's api
import TweenOne from './TweenOne';
import _tween from './Tween';
import group from './TweenOneGroup';
import _easing from './easing';
import _plugins from './plugins';
import _ticker from './ticker';

TweenOne.TweenOneGroup = group;
TweenOne.easing = _easing;
TweenOne.plugins = _plugins;
TweenOne.ticker = _ticker;
TweenOne.Tween = _tween;

export default TweenOne;

export var TweenOneGroup = group;

export var easing = _easing;

export var plugins = _plugins;

export var ticker = _ticker;

export var Tween = _tween;


//////////////////
// WEBPACK FOOTER
// ../~/rc-tween-one/es/index.js
// module id = 1059
// module chunks = 1